import { makeAutoObservable, runInAction, observable, autorun } from "mobx";
import { v4 as uuidv4 } from "uuid";
class OffcanvaTableStore {
  tableId = null;
  columnMap = new Map();
  rowMap = new Map();
  dynamicFlags = observable.map();
  filterOptions = [];
  isFetching = false;
  searchTerm = "";
  totalCount = 0;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {
      dynamicFlags: observable,
      searchTerm: observable,
    });
    autorun(() => {});
  }
  applytablebalue(value) {
    runInAction(() => {
      this.tableId = value;
    });
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.dynamicFlags.set(key, value);
      }
    });
  }
  setSearchTerm(term) {
    runInAction(() => {
      this.searchTerm = term;
    });
  }
  resetTableData() {
    runInAction(() => {
      this.columnMap.clear();
      this.rowMap.clear();
    });
  }
  get filteredRows() {
    if (!this.searchTerm) return this.getRows;
    const term = this.searchTerm.toLowerCase();
    return this.getRows.filter((row) =>
      this.getColumns.some((col) => {
        const value = row[col.key]?.value ?? row[col.key];
        return String(value).toLowerCase().includes(term);
      })
    );
  }
  async fetchTableColumnValues() {
    if (this.isFetching) return;
    runInAction(() => {
      this.isFetching = true;
      this.rootStore.callCommonLoader(true);
    });
    try {
      const response = await this.rootStore.commonAxios(
        "/getTableColumns",
        "GET",
        {
          tableId: this.rootStore.gridStore.childTableId,
          userId: this.rootStore.gridStore.userId,
        },
        {}
      );
      const fetchedColumns = response.data?.columns || [];
      const formattedColumns = [
        { id: "sno", label: "S.No", key: "sno" }, // Add the S.No column
        ...fetchedColumns.map((col) => ({
          id: col.columnId,
          label: col.customName || col.columnName,
          key: col.columnName,
        })),
      ];
      runInAction(() => {
         if (response?.data?.freshTable === true) {
          this.rootStore.gridStore.totalRecode = response?.data?.totalMatching;
        }
        this.setColumnData(formattedColumns);
        this.totalCount = response?.data?.totalCount ?? 0;
        this.rootStore.callCommonLoader(false);
      });
      return true;
    } catch (error) {
      this.rootStore.callCommonLoader(false);
      throw error;
    } finally {
      runInAction(() => {
        this.isFetching = false;
        this.fetchTableRecords(0);
      });
    }
  }
  async fetchTableRecords(offset = 0) {
    try {
      runInAction(() => {
        this.rootStore.callCommonLoader(true);
      });
      const tableId = this.rootStore.gridStore.childTableId;
      const userId = this.rootStore.gridStore.userId;
      const columnNames = this.getColumns.map((col) => col.key).join(",");
      const response = await this.rootStore.commonAxios(
        "/getTableRecords",
        "POST",
        {},
        {
          tableId,
          userId,
          offset,
          limit: 50,
          columns: columnNames,
          companyId: this.rootStore.gridStore.companyId,
        }
      );
      const records = response?.data?.list || [];
      runInAction(() => {
        this.setRowData(records);
        this.rootStore.callCommonLoader(false);
      });
    } catch (error) {
      this.rootStore.callCommonLoader(false);
    }
  }
  setColumnData(columns) {
    runInAction(() => {
      this.columnMap.clear();
      columns.forEach((col) => this.columnMap.set(col.id, col));
    });
  }
  setRowData(rows) {
    runInAction(() => {
      this.rowMap.clear();
      rows.forEach((row, index) => {
        row["sno"] = { value: index + 1 };
        this.rowMap.set(index, row);
      });
    });
  }
  get getColumns() {
    return Array.from(this.columnMap.values());
  }
  get getRows() {
    return Array.from(this.rowMap.values());
  }
}
export default OffcanvaTableStore;
